import React, { useState } from 'react';
import { availableCategories } from '../../Services/getCategories';
import { PrimaryButton, TextField } from '../../Components/ui';
import { classNames } from '../../utils/classNames';

const iconOptions = availableCategories.map((element) => ({
	name: element.name,
	url: element.url,
}));

const AddCustomCategory = ({ onAdd }) => {
	const [name, setName] = useState('');
	const [selectedIcon, setSelectedIcon] = useState(null);
	const [error, setError] = useState('');

	const handleAdd = () => {
		const trimmed = name.trim();

		if (!trimmed) {
			setError('Ingresa un nombre para la categoría');
			return;
		}

		if (!selectedIcon) {
			setError('Selecciona un ícono para la categoría');
			return;
		}

		onAdd({
			id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
			name: trimmed,
			url: selectedIcon,
		});

		setName('');
		setSelectedIcon(null);
		setError('');
	};

	return (
		<div className='mb-6 rounded-lg border border-dashed border-zinc-300 bg-zinc-50/60 p-4'>
			<p className='mb-3 text-sm font-semibold text-zinc-800'>
				Agregar categoría
			</p>

			<div className='flex flex-col gap-3 sm:flex-row sm:items-start'>
				<div className='flex-1'>
					<TextField
						id='custom-category-name'
						value={name}
						onChange={(e) => setName(e.target.value)}
						placeholder='Nursing'
					/>
				</div>
				<PrimaryButton type='button' size='md' onClick={handleAdd}>
					Agregar categoría
				</PrimaryButton>
			</div>

			<p className='mb-2 mt-4 text-xs font-medium text-zinc-600'>
				Selecciona un ícono:
			</p>

			<div className='grid max-h-48 grid-cols-4 gap-2 overflow-y-auto pr-1 sm:grid-cols-6'>
				{iconOptions.map((icon) => {
					const selected = selectedIcon === icon.url;
					return (
						<button
							key={icon.name}
							type='button'
							onClick={() => setSelectedIcon(icon.url)}
							className={classNames(
								'inline-flex items-center justify-center rounded-md border p-2 transition',
								selected
									? 'border-sky-500 bg-sky-50 ring-2 ring-sky-200'
									: 'border-zinc-200 bg-white hover:border-zinc-300 hover:bg-zinc-50',
							)}
						>
							<img
								src={icon.url}
								alt={icon.name}
								loading='lazy'
								className='h-7 w-7'
							/>
						</button>
					);
				})}
			</div>

			{error && <p className='mt-3 text-xs text-rose-600'>{error}</p>}
		</div>
	);
};

export default AddCustomCategory;
